exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.identity[data-v-35c0b064] {\n  width: 100%;\n  padding: 0.75rem;\n  box-sizing: border-box;\n}\n.box[data-v-35c0b064] {\n  background: #20DCC6;\n}\n.boRradius[data-v-35c0b064] {\n  border-radius: 0.4rem;\n}", ""]);

// exports
